import { render, staticRenderFns } from "./FuHorizontalNavigation.vue?vue&type=template&id=31f4c078&"
import script from "./FuHorizontalNavigation.vue?vue&type=script&lang=js&"
export * from "./FuHorizontalNavigation.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports